import * as moment from 'moment';

const mdMonthlyDueDate = ({ year, month }) => {
	// by 15th of next month

	if (year === null || year === undefined || month === null || month === undefined) {
		return moment().set('years', 1900).endOf('days');
	}

	const months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

	if (false === months?.includes(month)) {
		return moment().set('years', 1900).endOf('days');
	}

	const due = moment().month(month).year(year).add(1, 'month').date(15).endOf('day');
	return due;
};

const mdQuarterlyDueDate = ({ year, quarter }) => {
	// by 15th of first month of next quarter

	if (year === null || year === undefined || quarter === null || quarter === undefined) {
		return moment().set('years', 1900).endOf('days');
	}

	const quarters = [1, 2, 3, 4];

	if (false === quarters?.includes(quarter)) {
		return moment().set('years', 1900).endOf('days');
	}

	const due = moment().quarter(quarter).year(year).add(1, 'quarter').startOf('quarter').date(15).endOf('day');
	return due;
};

const mdAnnuallyDueDate = ({ year }) => {
	// 31st march of next year

	if (year === null || year === undefined) {
		return moment().set('years', 1900).endOf('days');
	}

	const due = moment().year(year).endOf('year').add(3, 'month').endOf('month').endOf('day');
	return due;
};

export { mdMonthlyDueDate, mdQuarterlyDueDate, mdAnnuallyDueDate };
